var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-runtime/~/core-js/library/modules/_uid.js
// module id = 847
// module chunks = 2